<div aria-hidden="true"
     class="measure-con"
     role="presentation"
     tabindex="-1">
    <div class="hidden-measure tabset">
        <slot>
            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </slot>
    </div>
</div>
<div class="visible tabset">
    <ng-container *ngTemplateOutlet="tabContent"></ng-container>
</div>
<ng-template #tabContent>
    <ng-content></ng-content>
</ng-template>
